import { render, staticRenderFns } from "./UserSettingsPhoto.vue?vue&type=template&id=1f696c8d"
import script from "./UserSettingsPhoto.vue?vue&type=script&lang=js"
export * from "./UserSettingsPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports